"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyBooksToggle = void 0;
var _MyBooksToggle = require("./MyBooksToggle.styles");
var _jsxRuntime = require("react/jsx-runtime");
const MyBooksToggle = () => {
  const styles = (0, _MyBooksToggle.useStyles)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Book__my-books-toggle'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {})]
  });
};
exports.MyBooksToggle = MyBooksToggle;